/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { makeStyles } from 'tss-react/mui';

import { Theme } from '@mui/material/styles';

const EntryDetailViewStyles = makeStyles()((theme: Theme) => ({
	detailImage: {
		maxWidth: '1200px',
		maxHeight: '800px',
	},

	paper: {
		height: '100%',
		maxHeight: 'calc(100% - 164px);',
		maxWidth: '1000px',
	},

	cancelButton: {
		padding: '0px',
		height: '24px',
		marginLeft: theme.spacing(1),
		marginTop: 'auto',
		marginBottom: 'auto',
	},

	contentContainer: {
		height: '100%',
	},

	contentLeft: {
		height: '100%',
	},

	contentRight: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		padding: theme.spacing(0, 4),
	},

	imageBox: {
		width: '100%',
		height: '100%',
		position: 'relative',
		overflow: 'hidden',
		borderRadius: '8px 0px 0px 8px',
	},

	imageBlur: {
		minWidth: '100%',
		minHeight: '100%',
		position: 'absolute',
		top: '50%',
		left: '50%',
		zIndex: 1,
		filter: 'blur(8px)',
		transform: 'translate(-50%, -50%) scale(1.1)',
	},

	image: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		maxWidth: '100%',
		maxHeight: '100%',
		cursor: 'pointer',
		boxShadow: '0px 0px 3px grey',
		zIndex: 2,
	},

	rejectedBox: {
		width: '100%',
		height: '80px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		backgroundColor: '#F4430B',
		position: 'absolute',
		top: 0,
		zIndex: 3,
	},

	rejectedTextBox: {
		display: 'flex',
		justifyContent: 'center',
	},

	rejectedIcon: {
		width: '24px',
		height: '24px',
		color: '#FFFFFF',
		marginRight: theme.spacing(2),
	},

	rejectedTitle: {
		color: '#FFFFFF',
	},

	rejectedText: {
		fontFamily: theme.typography.fontFamilyBold,
		color: '#FFFFFF',
	},
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default EntryDetailViewStyles;
